import { Container, Row, Col } from "react-bootstrap";
import React, { useEffect, useState, useRef, useMemo } from "react";
import apiCall from "../Api/api";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Link, useParams } from "react-router-dom";
import path from "../../assets/img/locationpath.svg";
import print from "../../assets/img/printP.png";
import rupees from "../../assets/img/rupees.png";
import { useParksContext } from "../../provider/ParksProvider";
import { useMasterContext } from "../../provider/MasterProvider";
import { useSearchParams } from "react-router-dom";
import rupeeFormat from "../Api/RupeeFormat";
import ParkCardSekelton from "../common/Skeleton/park/ParkCardSekelton";
import AnimalsParkFilter from "./AnimalsParkFilter";
import { useScreenSize } from "provider/ScreenSizeProvider";
import AnimalsParkMobileFilter from "./AnimalsParkMobileFilter";

const AnimalSafariList = ({ animalRare = [] }) => {
  const {animalSlug} = useParams();
  const { raParkData, raPageIndex, summary, raFilters, parksDispatch } =   useParksContext();
  const { masterLoading, parksSortBy } = useMasterContext();
  const [, setSearchParams] = useSearchParams();
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);
  const { isMobileView } = useScreenSize();
  const [showFilter, setShowFilter] = useState(false);
  const loaderRef = useRef(null);
  const isFetchingRef = useRef(false);
  const triggerRef = useRef(false);

  useEffect(() => {
    parksDispatch({ type: "SET_RA_PAGE_INDEX", payload: 1 });
  }, []);

  useEffect(() => {
    parksDispatch({ type: "SET_RA_PAGE_INDEX", payload: 1 });
    // parksDispatch({ type: "SET_RA_PARKS_DATA", payload: [] });
    setHasMore(true);
  }, [raFilters]);

  useEffect(() => {
    const fetchParks = async () => {
      if (isFetchingRef.current) return;
      isFetchingRef.current = true;
      setLoading(true);
      try {
        const queryParams = new URLSearchParams();
        Object.entries(raFilters).forEach(([key, value]) => {
          if (Array.isArray(value) && value.length > 0) {
            value.forEach((v) => queryParams.append(`${key}[]`, v));
          } else if (value !== 0 && value !== null && value !== "") {
            queryParams.append(key, value);
          }
        });

        if (summary?.pageSize) queryParams.append("pageSize", summary.pageSize);
        if (raPageIndex) queryParams.append("page", raPageIndex);

        const response = await apiCall({
          url: `park?master_animal_slug=${animalSlug}&${queryParams.toString()}`,
          method: "GET",
        });

        const parkData = response?.data?.parks?.data || [];
        const parkSummary = response?.data?.parks?.summary;

        if (raPageIndex === 1) {
          parksDispatch({ type: "SET_RA_PARKS_DATA", payload: parkData });
        } else {
          parksDispatch({ type: "APPEND_RA_PARKS_DATA", payload: parkData });
        }

        parksDispatch({
          type: "RA_PARKS_SUMMARY",
          payload: {
            total: parkSummary.total,
            page: parkSummary.page,
            pageSize: parkSummary.pageSize,
            total_page: parkSummary.total_page,
          },
        });

        if (raPageIndex >= parkSummary?.total_page) {
          setHasMore(false);
        }
      } catch (err) {
        console.error("Error fetching parks:", err);
      } finally {
        setLoading(false);
        isFetchingRef.current = false;
      }
    };

    fetchParks();
  }, [summary?.pageSize, raFilters, raPageIndex]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const target = entries[0];
        if (
          target.isIntersecting &&
          hasMore &&
          !loading &&
          !triggerRef.current
        ) {
          triggerRef.current = true;
          parksDispatch({ type: "SET_RA_PAGE_INDEX", payload: raPageIndex + 1 });
        }
      },
      { threshold: 1.0 }
    );

    if (loaderRef.current) observer.observe(loaderRef.current);
    return () => {
      if (loaderRef.current) observer.unobserve(loaderRef.current);
    };
  }, [hasMore, loading]);

  useEffect(() => {
    // Reset triggerRef once loading completes
    if (!loading) triggerRef.current = false;
  }, [loading]);

  const handleSortChange = (e) => {
    parksDispatch({ type: "SET_RA_PAGE_INDEX", payload: 1 });
    const value = Number(e.target.value);
    updateFilter("custom_sort_by", value);
  };
  const updateFilter = (name, value) => {
    parksDispatch({
      type: "UPDATE_RA_PARKS_FILTER",
      payload: { [name]: value },
    });
  };

  useEffect(() => {
    const newParams = new URLSearchParams();

    // Add raFilters to URL params
    Object.entries(raFilters).forEach(([key, value]) => {
      if (Array.isArray(value) && value.length > 0) {
        value.forEach((v) => newParams.append(`${key}[]`, v));
      } else if (value !== 0 && value !== null && value !== "") {
        newParams.set(key, value);
      }
    });

    // Add page
    newParams.set("page", raPageIndex);

    setSearchParams(newParams);
  }, [raPageIndex, raFilters, parksSortBy]);

   const handleFilterClick = () => {
    setShowFilter(true); // or toggle with !showFilter if you want toggle behavior
  };


  const processedParks = useMemo(() => {
    return raParkData?.map((park) => ({
      ...park,
    }));
  }, [raParkData, raPageIndex]);

  return (
    <>
      <section className="banner_section-inner packagebnner position-relative">
        <picture className="position-relative">
          <source
            srcSet={"/img/baneer1719164625.jpg"}
            media="(max-width:576px)"
            type="image/jpg"
          />
          <img
            src="/img/baneer1719164625.jpg"
            className="d-block w-100 banner_search"
            alt="banner"
            type="image/jpg"
            loading="lazy"
          />
        </picture>
        <div className="banner_searchBox">
          <Container>
            <Row>
              <Col xs={12}>
                <div className="headingBnner_inner">
                  <h1>{animalRare[0]?.name || "Animal Safari"}</h1>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </section>

      <section className="articals_wrapper margin_bottomfooter mt-lg-4">
        <Container fluid>
          <Row className="justify-content-center">
            <Col xl={10}>
              <Row>
                 {!isMobileView && <Col
                  xl={2}
                  lg={2}
                  xs={12}
                  className="mb-lg-0 mb-3 filter-sidebar-sticky"
                >
                  <AnimalsParkFilter />
                </Col>
                }
                {isMobileView && <div
                  id="targetDiv"
                  className="mobileDive"
                  style={{ display: showFilter ? "block" : "none" }}
                >
                  <AnimalsParkMobileFilter onCancel={() => setShowFilter(false)} />
                </div>
                }
                {isMobileView && <Col xs={12} className="px-0 d-lg-none">
                  <div className="top_mobilefilter d-flex gap-2  justify-content-between align-items-center w-100 mb-4">
                    <div className="left_text">
                      <p className="mb-0">
                        We found{" "}
                        <strong className="parklistcount">
                          {processedParks?.length} Parks
                        </strong>{" "}
                        for you
                      </p>
                    </div>
                    <div className="right-select mobile_serach mb-md-0 ">
                      <div className="input_check pb-0">
                        <div className="filter_searchbox" onClick={handleFilterClick}>
                          <span>Filter <i className="fa-solid fa-chevron-down"></i></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
                }

                <Col xl={10} lg={10} xs={12} className="paddingset_desktop">
                  <div className="topfilter d-lg-flex d-none justify-content-between align-items-center w-100 mb-2">
                    <div className="left_text">
                      <p className="mb-0">
                        We found{" "}
                        <strong className="parklistcount">
                          {processedParks?.length} Parks
                        </strong>{" "}
                        for you
                      </p>
                    </div>
                    <div className="right-select mb-md-0 mb-4">
                      <div className="input_check pb-0">
                        <form id="custom_sort_by_form">
                          <select
                            id="sharesafarisearch-custom_sort_by"
                            name="custom_sort_by"
                            aria-label="Default select example"
                            className="form-select mb-2 custom_sort_by_input"
                            value={raFilters?.custom_sort_by}
                            onChange={handleSortChange}
                          >
                            {Array.isArray(parksSortBy) &&
                            parksSortBy?.length > 0 ? (
                              parksSortBy?.map((option) => (
                                <option key={option.value} value={option.value}>
                                  {option.label}
                                </option>
                              ))
                            ) : masterLoading ? (
                              <option key={"1"} value={""}>
                                {"Sort by : Most Demanding"}
                              </option>
                            ) : (
                              <p>No Filter available</p>
                            )}
                          </select>
                        </form>
                      </div>
                    </div>
                  </div>

                  {Array.isArray(processedParks) &&
                  processedParks?.length > 0 ? (
                    processedParks?.map((park, index) => (
                      <Link
                        key={index}
                        to={`/park/${park.slug}`}
                        className="parking_Box"
                        data-pjax="0"
                      >
                        <div className="searchSafari_wraper mb-4">
                          <Row>
                            <Col md={3} xs={12}>
                              <div className="Slider_safariimg3 h-100 w-100">
                                <img
                                  src={park.feature_image_path}
                                  alt={park.title || "Park image"}
                                  className="w-100 h-100"
                                />
                              </div>
                            </Col>
                            <Col md={9} xs={12}>
                              <div className="safariSearch_wrap">
                                <div className="safrititles tite_parklist pt-sm-0 pt-3">
                                  <h4>{park.title} </h4>
                                </div>
                                <div className="detailesOrLocation d-flex justify-content-between flex-wrap">
                                  <div className="items_bg d-flex gap-1">
                                    <div className="top_list">
                                      <img src={path} alt="" />
                                    </div>
                                    <div>
                                      <div className="d-flex flex-column">
                                        <span className="mark_area">
                                          Location
                                        </span>
                                        <span className="titles_filed">
                                          {`${park.state?.state_name}, ${park.location?.title}`}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="items_bg d-flex gap-1">
                                    <div className="top_list">
                                      <img
                                        src={print}
                                        alt=""
                                        style={{ height: "16px" }}
                                      />
                                    </div>
                                    <div className="d-flex flex-column">
                                      <span className="mark_area">
                                        Wildlife Found
                                      </span>
                                      <span className="titles_filed">
                                        {park?.animal_text
                                          ?.split(" ")
                                          .slice(0, 6)
                                          .join(" ") +
                                          (park?.animal_text?.split(" ")
                                            .length > 6
                                            ? "..."
                                            : "")}
                                      </span>
                                    </div>
                                  </div>
                                  <div className="items_bg d-flex gap-1">
                                    <div className="top_list">
                                      <img
                                        src={rupees}
                                        alt=""
                                        style={{ height: "16px" }}
                                      />
                                    </div>
                                    <div className="d-flex flex-column">
                                      <span className="mark_area">
                                        Safari Cost
                                      </span>
                                      <span className="titles_filed">
                                        {`${rupeeFormat(
                                          park.avg_safari_price_min
                                        )} - ${rupeeFormat(
                                          park.avg_safari_price_max
                                        )}`}
                                        <span className="avg_price">
                                          Average Safari Price*
                                        </span>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div className="seelctes_text pt-2 pb-4">
                                  <p>
                                    {park?.top_operators?.[0]?.about_business}
                                  </p>
                                </div>
                                <div className="tour_logosliders">
                                  <div className="touroprators text-center">
                                    <div className="more_btn">Know More</div>
                                  </div>
                                </div>
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </Link>
                    ))
                  ) : loading ? (
                    <ParkCardSekelton />
                  ) : (
                    <p>No Park available</p>
                  )}

                  {hasMore && (
                    <div ref={loaderRef} className="text-center py-4">
                      <span>Loading more parks...</span>
                    </div>
                  )}
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default AnimalSafariList;

